import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Paper, Typography } from '@mui/material';

import { formatDateTime } from '@utils/dateHelpers';

import type { CustomerSignoff } from '@features/calibration/hooks/useCalibrationRuntime/types';

type Props = {
  signoff: CustomerSignoff;
};

const HistoryCustomerSignoff: React.FC<Props> = ({ signoff }) => {
  const { t } = useTranslation('history');

  return (
    <Paper elevation={1} sx={{ p: { xs: 2, sm: 3 }, width: '100%' }}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        {t('signoff.title')}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 3,
          alignItems: { sm: 'flex-start' }
        }}
      >
        <Box
          component="img"
          src={signoff.signatureDataUrl}
          alt={signoff.printedName}
          sx={{
            maxWidth: 300,
            maxHeight: 120,
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            p: 1,
            backgroundColor: 'background.default'
          }}
        />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('signoff.printedName')}
            </Typography>
            <Typography variant="body2">{signoff.printedName}</Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('signoff.signedAt')}
            </Typography>
            <Typography variant="body2">
              {formatDateTime(signoff.timestamp)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default HistoryCustomerSignoff;
